import clsx from 'clsx';
import styles from './Logo.module.css';

/** HSI Label mark (a cube of spectral bands) + optional word mark. */
export function Logo({ withText = true, className }: { withText?: boolean; className?: string }) {
  return (
    <span className={clsx(styles.logo, className)}>
      <svg viewBox="0 0 32 32" className={styles.mark} aria-hidden>
        <rect x="3" y="3" width="26" height="26" rx="7" fill="var(--accent)" />
        <rect x="8" y="9" width="16" height="3" rx="1.5" fill="#fbbf24" />
        <rect x="8" y="14.5" width="16" height="3" rx="1.5" fill="#f2f4f7" />
        <rect x="8" y="20" width="16" height="3" rx="1.5" fill="#7dd3fc" />
      </svg>
      {withText && <span className={styles.text}>HSI Label</span>}
    </span>
  );
}
